/** URL suffixes appended after `/offers/<id>`, shared by the client mutation builder and the server-side decision steps; a typo on either side silently 404s the seller's accept / reject CTA. */

export const NAVIGATOR_OFFER_ACTIONS = {
	ACCEPT: 'accept',
	REJECT: 'reject',
} as const;

export type NavigatorOfferAction = (typeof NAVIGATOR_OFFER_ACTIONS)[keyof typeof NAVIGATOR_OFFER_ACTIONS];
